import React, { useMemo } from 'react';
import {
  StyledContainer,
  StyledFormContainer,
  StyledHeaderTitle,
  StyledImage,
  StyledOverview,
} from './Overview.styled';
import { useFeatureFlags } from '../../../contexts/FeatureFlagsContext';
import B2CForm from '../../B2CForm/B2CForm';
import B2BForm from '../../B2BForm/B2BForm';
import { useTranslation } from '../../../hooks/useTranslation';
import { PAGE_URL, SERVICE_FORM_SCREEN } from '../../../config/appConfig';
import { getNavigationItems } from '../Header/HeaderConfig';
import CategoryHeading from '../../Heading/CategoryHeading';

/**
 * Represents a section providing an overview of a service.
 *
 * @component
 * @param {Object} props - The component props.data.
 * @param {string} props.data.image - The URL of the overview image.
 * @param {string} props.data.title - The title of the overview.
 * @param {string[]} props.data.paragraph - An array of paragraphs containing overview text.
 * @returns {JSX.Element} JSX element representing the Overview component.
 */

const Overview = (props) => {
  const featureFlag = useFeatureFlags();
  const t = useTranslation();
  const currentPath = window.location.pathname;
  const renderFrom = useMemo(() => {
    const form = {
      [PAGE_URL.SERVICES_B2C]: (
        <B2CForm source={SERVICE_FORM_SCREEN.B2C} key={currentPath} />
      ),
      [PAGE_URL.SERVICES_B2B]: (
        <B2CForm source={SERVICE_FORM_SCREEN.B2B} key={currentPath} />
      ),
      [PAGE_URL.SERVICES_CBL]: (
        <B2CForm source={SERVICE_FORM_SCREEN.INTERNATIONAL} key={currentPath} />
      ),
      [PAGE_URL.SERVICES_TPL]: (
        <B2BForm source={SERVICE_FORM_SCREEN.THIRD_PARTY_LOGISTICS} />
      ),
    };
    return form[currentPath];
  }, [currentPath]);

  const renderNewOverviewPage = () => {
    return (
      <StyledContainer
        className='container'
        id='Overview'
        data-testid='new-overview-page'
      >
        <div className='overview-content'>
          <StyledFormContainer
            className='overview-form'
            data-testid='new-overview-form'
          >
            {renderFrom || <B2CForm />}
          </StyledFormContainer>
          <img
            src={props.data.image}
            alt={props.data.alt}
            className='img-fluid'
            loading='lazy'
            data-testid='new-overview-image'
          />
        </div>
      </StyledContainer>
    );
  };
  return renderNewOverviewPage();
};

export default Overview;
